import { getCognitoUserPool } from 'aws';

export function useAuth() {
  const userPool = getCognitoUserPool();
  const cognitoUser = userPool.getCurrentUser();

  return !!cognitoUser;
}
